import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Tooltip
} from "@mui/material";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { dashboardIcon, images } from "../../config/images";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import translations from "../../config/language";

const SideMenu = ({
  isSidebarOpen,
  setIsSidebarOpen,
  selectedIndex,
  setSelectedIndex,
  isLogoutOpen, 
  changePassword
}) => {

  const { role } = useSelector((state) => state.userState);
  const admin = role == 3;

  const language = process.env.REACT_APP_LANGUAGE;

  const sidebarItems = [
    {
      icon: dashboardIcon.dashboardIcon,
      label: translations[language].dashboard,
      link: "/dashboard",
      admin: true,
    },
    {
      icon: dashboardIcon.farmerIcon,
      label: translations[language].farmers,
      link: "/farmer",
      admin: true,
    },
    {
      icon: dashboardIcon.taskAssign,
      label: translations[language].taskAssignment,
      link: "/task-assignment",
      admin: true,
    },
    {
      icon: dashboardIcon.collectorListIcon,
      label: translations[language].dataCollectors,
      link: "/collectors-list",
      admin: true,
    },
    {
      icon: dashboardIcon.ReportIcon,
      label: translations[language].reportSubmission,
      link: "/report-submission",
      admin: true,
    },
    {
      icon: dashboardIcon.userManagementIcon,
      label: translations[language].userManagement,
      link: "/user-management",
      admin: false,
    },
    {
      icon: dashboardIcon.RegionIcon,
      label: translations[language].regionAndLocality,
      link: "/region-locality",
      admin: true,
    },
    {
      icon: dashboardIcon.cropsIcon,
      label: translations[language].typeOfCrops,
      link: "/crops",
      admin: false,
    },
    {
      icon: dashboardIcon.livestockIcon,
      label: translations[language].typeOfLivestock,
      link: "/livestock",
      admin: false,
    },
    {
      icon: dashboardIcon.piscicultureIcon,
      label: translations[language].typeOfPisciculture,
      link: "/pisciculture",
      admin: false,
    },
    {
      icon: dashboardIcon.machineryIcon,
      label: translations[language].typeOfMachinery,
      link: "/machinery",
      admin: false,
    },
    {
      icon: dashboardIcon.certificationIcon,
      label: translations[language].certificationsAndTraining,
      link: "/certification",
      admin: false,
    },
    {
      icon: dashboardIcon.trainingIcon,
      label: translations[language].trainingProgram,
      link: "/training-program",
      admin: false,
    },
    {
      icon: dashboardIcon.whoSponsoredIcon,
      label: translations[language].whoSponsored,
      link: "/sponsored",
      admin: false,
    },

  ];

  return (
    <Box sx={{
      height: "100vh", backgroundColor: "#f5f5f5",
      display: "flex",
      zIndex: (isLogoutOpen || changePassword) ? 0 : 1000, // If either is true, zIndex is 0
    }}>
      <Box
        sx={{
          width: isSidebarOpen ? "250px" : "87px",
          transition: "width 0.3s",
          position: "fixed",
          height: "85vh",
          background: "#fff",
          boxShadow: "2px 0px 5px rgba(0, 0, 0, 0.1)",
          overflowY: "auto",
          marginLeft: "18px",
          borderRadius: "12px 12px 0px 0px"
        }}
        className="sidemenu-box"
      >
        <Box>
          {sidebarItems
            .filter((item) => (admin ? item.admin : true)) // Show only admin items if admin is true
            .map((item, index) => (
              <Link key={item.label} to={item.link}>
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: isSidebarOpen ? "12px 16px" : "12px 22px",
                    gap: "10px",
                    cursor: "pointer",
                    backgroundColor:
                      selectedIndex === item.label ? "#2E9559" : "transparent",
                    color: selectedIndex === item.label ? "#fff" : "black",
                    borderRadius: index === 0 ? "8px 8px 0px 0px" : "0px",
                  }}
                  onClick={() => setSelectedIndex(item.label)}
                >
                  <Tooltip
                    title={!isSidebarOpen ? item.label : ""}
                    placement="right"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#31A05F",
                          color: "#fff",
                          fontSize: "14px",
                          borderRadius: "6px",
                          padding: "8px 12px",
                        },
                      },
                    }}
                  >
                    <Box sx={{ minWidth: "40px", textAlign: "center" }}>
                      <img
                        src={item.icon}
                        alt=""
                        style={{ width: "30px", height: "30px" }}
                      />
                    </Box>
                  </Tooltip>
                  {isSidebarOpen && <Typography className="sidemenu-label">{item.label}</Typography>}
                </Box>
              </Link>
            ))}
        </Box>
      </Box>
    </Box>
  );
};
export default SideMenu;
